var TimePicker = /** @class */ (function () {
    function TimePicker(slot, options) {
        this.slot = slot;
        this.options = options || {};
    }
    Object.defineProperty(TimePicker.prototype, "cssPrefix", {
        get: function () {
            return 'kdtp-tp';
        },
        enumerable: true,
        configurable: true
    });
    TimePicker.prototype.setTime = function (time) {
        this.currentTime = new Date(time);
    };
    TimePicker.prototype.getTime = function () {
        return new Date(this.currentTime);
    };
    TimePicker.prototype.timeChanged = function () {
        if (this.options.onTimeChanged) {
            this.options.onTimeChanged(this.currentTime);
        }
    };
    return TimePicker;
}());
export { TimePicker };
//# sourceMappingURL=time_picker.js.map